"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation = void 0;
var joi_1 = __importDefault(require("joi"));
exports.operation = joi_1.default.object({
    approverFirstName: joi_1.default.string()
        .min(0)
        .max(15)
        .allow('')
        .optional(),
    approverID: joi_1.default.string()
        .guid({ version: ['uuidv4', 'uuidv5'] })
        .allow('')
        .optional(),
    approverLastName: joi_1.default.string()
        .min(0)
        .max(25)
        .allow('')
        .optional(),
    cmhcOwnerEmployeeNumber: joi_1.default.string()
        .min(0)
        .max(8)
        .allow('')
        .optional(),
    cmhcOwnerFirstName: joi_1.default.string()
        .min(0)
        .max(15)
        .allow('')
        .optional(),
    cmhcOwnerID: joi_1.default.string()
        .guid({ version: ['uuidv4', 'uuidv5'] })
        .allow('')
        .optional(),
    cmhcOwnerLastName: joi_1.default.string()
        .min(0)
        .max(25)
        .allow('')
        .optional(),
    lastRecordUpdatedUserFirstName: joi_1.default.string()
        .min(0)
        .max(15)
        .required(),
    lastRecordUpdatedUserLastName: joi_1.default.string()
        .min(0)
        .max(25)
        .required(),
    lastRecordUpdatedTimestamp: joi_1.default.string()
        .regex(/(\d{4}-\d{2}-\d{2})(-| )(\d{2})(:|.)(\d{2})(:|.)(\d{2})(.)(\d{1,6})$/)
        .required(),
    lastRecordUpdatedUserID: joi_1.default.number()
        .min(0)
        .integer()
        .max(2147483648)
        .options({ convert: false })
        .required(),
    requestReceivedTimestamp: joi_1.default.string()
        .regex(/(\d{4}-\d{2}-\d{2})(-| )(\d{2})(:|.)(\d{2})(:|.)(\d{2})(.)(\d{1,6})$/)
        .required(),
});
exports.default = { operation: exports.operation };
